import { render, staticRenderFns } from "./LogoMockup.vue?vue&type=template&id=2da75d98&"
import script from "./LogoMockup.vue?vue&type=script&lang=js&"
export * from "./LogoMockup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports